module.exports = __webpack_public_path__ + "media/智能--新风系统.fd7dc91a.mp4";